const { BACKEND_URL } = require("./consts");

module.exports.getProfile = async () => {
    const responseProfile = await fetch(`${BACKEND_URL}/api/v1/profile`);

    if (responseProfile.ok) {
        return await responseProfile.json();
    }

    return null;
}
